'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from '../system/forward-ref.mjs';
import { chakra } from '../system/factory.mjs';

const TooltipArrow = forwardRef(
  function TooltipArrow2(props, ref) {
    return /* @__PURE__ */ jsx(
      chakra.div,
      {
        ref,
        "data-popper-arrow": true,
        className: "chakra-tooltip__arrow",
        ...props,
        children: /* @__PURE__ */ jsx(
          chakra.div,
          {
            "data-popper-arrow-inner": true,
            className: "chakra-tooltip__arrow-inner",
            __css: { bg: "inherit" }
          }
        )
      }
    );
  }
);
TooltipArrow.displayName = "TooltipArrow";

export { TooltipArrow };
